import request from '@/config/request';
import API from '@/config/domain';

export default {
  // 角色管理-列表接口
  loadRoles(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/role/loadRoles', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 角色管理-角色删除
  deleteRoleById(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/role/deleteRoleById', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 角色管理-角色启用停用
  updateRoleStatus(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/role/updateRoleStatus', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 角色管理-菜单初始化
  loadMenu(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubMenu/loadMenu', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 角色管理-根据id查询角色详情
  loadRoleById(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/role/loadRoleById', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 角色管理-数据保存接口
  mergeRole(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/role/mergeRole', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户管理-列表接口
  queryUserList(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/queryUserList', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户管理-账号启用/停用
  updateUserStatus(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/updateUserStatus', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户管理-新增/修改用户
  mergeUser(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/mergeUser', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户管理-用户详情
  loadUserById(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/loadUserById', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户管理-删除
  deleteUser(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/deleteUser', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 组织机构-列表
  pagePubOrganInfoList(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/pagePubOrganInfoList', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 组织机构-明细
  getOrgDetailById(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/getOrgDetailById', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 组织机构-新增/维护接口
  mergeOrgInfo(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/mergeOrgInfo', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 组织机构-状态更改
  updateOrganDataStatus(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/updateOrganDataStatus', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 组织机构-删除接口
  deleteOrganById(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/deleteOrganById', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 部门-列表接口
  pagePubDeptInfo(params, callback) {
    return request(API.BASEAPI + 'rest/pubDeptInfo/pagePubDeptInfo', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 部门-状态更改
  updatePubDeptStatus(params, callback) {
    return request(API.BASEAPI + 'rest/pubDeptInfo/updatePubDeptStatus', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 部门-删除
  deletePubDeptInfo(params, callback) {
    return request(API.BASEAPI + 'rest/pubDeptInfo/deletePubDeptInfo', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 部门-新增/维护接口
  savePubDeptInfo(params, callback) {
    return request(API.BASEAPI + 'rest/pubDeptInfo/savePubDeptInfo', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 部门-明细列表
  getPubDeptInfo(params, callback) {
    return request(API.BASEAPI + 'rest/pubDeptInfo/getPubDeptInfo', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 获取重置密码
  getResetLoginPwd(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/getResetLoginPwd', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 重置密码
  resetLoginPwd(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/resetLoginPwd', 'post', params).then((data) => {
      callback(data);
    });
  },

  // 角色管理-菜单初始化
  getAllAreaInfoTreeForUser(params, callback) {
    return request(API.BASEAPI + 'rest/area/getAllAreaInfoTreeForUser', 'post', params).then((data) => {
      callback(data);
    });
  },
  
};